(function () {
  try {
    const bgPic = (() => {
      const stateRaw = window.localStorage.getItem('state');
      const ui = (stateRaw ? JSON.parse(stateRaw) : {}).ui;

      if (!ui) return null;

      if (ui.mode === 'custom') {
        return { url: ui.customPicture.pictureUrl || ui.customPicture.raw };
      }

      if (['gallery', 'speed', 'focus'].includes(ui.mode)) {
        if (ui.gallery.nextImage?.status === 'READY') {
          return ui.gallery.nextImage.picture;
        }

        return ui.gallery.image.picture;
      }

      return null;
    })();

    const $img = document.querySelector('#bg-picture img');
    if (bgPic && bgPic.url && $img) {
      $img.src = bgPic.url;
    }
  } catch (err) {
    console.error('bgPic', err);
  }
})();
